// extracted by mini-css-extract-plugin
module.exports = {"MenuBar":"MenuBar_MenuBar_k1avi"};